module.exports = __webpack_public_path__ + "static/media/8.8e2b5bd4.png";